import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Tenant Configuration API
 */
class TenantConfigurationApi extends ApiBase {
  async get(name) {
    const request = {
      url: `${this.API_URL}/tenantconfigurations?nameOrCategory=${name}`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new TenantConfigurationApi();
